import { ITongHopHocPhiRequest } from "../../state/reducer-model/tong-hop/ITongHopHocPhiReducer";
import { apiClient } from "../apiClient";
export const TONG_HOP_HOC_PHI_API = "tong-hop-hoc-phi";
export const tongHopHocPhiApi = {
  ExportExcel: (request: ITongHopHocPhiRequest) =>
    apiClient.post(`${TONG_HOP_HOC_PHI_API}/export-excel`, request),
};
